/* eslint-disable max-lines-per-function */
/* eslint-disable array-callback-return */
/* eslint-disable camelcase */
/**
 * @file  Events
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useEffect, useState, useContext} from 'react';
import {message, Collapse, Button, Divider} from 'antd';
import Iconfont from '~/component/Iconfont';
import {BasicLayoutContext} from '~/layout/BasicLayout';
import {unique} from '~/utils/function';
import {getByChannelCode, getInfoById} from '~/service/cms';
import './index.less';

const codeList = ['channel_ir_agm', 'channel_ir_past_agm'];
const {Panel} = Collapse;

function Agm() {
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [list, setList] = useState([]);
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    useEffect(() => {
        window.scrollTo(0, 0);
        getByChannelCode({codeList})
            .then(({data}) => {
                const {channel_ir_agm, channel_ir_past_agm} = data;
                const {uid, content: {title}} = channel_ir_agm.contentResponseList[0];
                setTitle(title);
                getInfoById({uid})
                    .then(({data}) => {
                        const {content: {content}} = data;
                        setContent(content);
                    })
                    .catch(() => {
                        message.error('获取AGM/EGM详情失败');
                    });
                const {contentResponseList} = channel_ir_past_agm;
                // 将返回的数据中的year组成一个数组，并将数组倒序排序并去重
                let arrNew = [];
                const yearArr = contentResponseList.map(item => item?.content?.year).sort((a, b) => b - a);
                arrNew = unique(yearArr);
                // 筛选年份相同的数据
                let newList = [];
                arrNew.map(year => {
                    const agmList = contentResponseList.filter(item => item?.content?.year ===  year);
                    newList = newList.concat(agmList);
                });
                // 将相同年份的数据中的earningsRelease拼接成一个新数组
                newList = newList.reduce((prev, cur, index) => {
                    if (prev[index - 1]?.content?.year !== cur?.content?.year) {
                        return prev.concat(cur);
                    }
                    const {content} = prev[index - 1];
                    content.earningsRelease
                        = content.earningsRelease.concat(cur.content.earningsRelease);
                    return prev;
                }, []);
                setList(newList);
            })
            .catch(() => {
                message.error('获取AGM/EGM失败');
            });
    }, []);


    return (
        <div className="agm-container">
            {
                isMobile && (
                    <>
                        <div className="agm-container-title">
                            AGM/EGM
                        </div>
                        <Divider />
                    </>
                )
            }
            <div className="agm-title">
                {title}
            </div>
            <div
                className="agm-content"
                dangerouslySetInnerHTML={{__html: content}}
            >
            </div>

            <Collapse
                bordered={false}
                defaultActiveKey={['1']}
                // eslint-disable-next-line react/jsx-no-bind
                expandIcon={
                    ({isActive}) => (
                        <Iconfont
                            type="iconxiala" rotate={isActive ? 0 : 180}
                        />
                    )}
                className="site-collapse-custom-collapse"
                expandIconPosition="right"
                ghost
            >

                {
                    list.map(item => (
                        <Panel
                            header={item.content.year}
                            key={item.content.year}
                            className="site-collapse-custom-panel"
                        >
                            {
                                item.content.earningsRelease.map((value, key) => (
                                    <Button
                                        key={key.id}
                                        icon={<Iconfont type="iconPDF" />}
                                        // eslint-disable-next-line react/jsx-no-bind
                                        onClick={() => {
                                            window.open(value.url);
                                        }}
                                    >
                                        {value.name}
                                    </Button>
                                ))
                            }
                        </Panel>
                    ))
                }
            </Collapse>
        </div>
    );
}

export default Agm;
